import React from 'react';
import { useState } from 'react';
import { Button } from 'reactstrap';
import { Link } from 'react-router-dom';

import { useTranslator, useAppContext } from '@front-activerse/common-components';

interface RemoteConfigFields {
  tracker_notification_id: number;
  tracker_notification_active: boolean;
}

interface TrackerNotificationAlertProps {
  userId: number;
  trackerNotificationData: RemoteConfigFields;
  getClosedNotificationsValues: () => Promise<void>;
  markNotificationAsClosed: (
    collectionName: string,
    userId: number,
    notificationId: number
  ) => Promise<void>;
}

const TrackerNotificationAlert: React.FC<TrackerNotificationAlertProps> = ({
  userId,
  trackerNotificationData,
  markNotificationAsClosed,
}) => {
  const { t } = useTranslator();

  const { tracker_notification_id } = trackerNotificationData;

  const [isClosed, setIsClosed] = useState(false);

  const {
    images: { macroSettings },
  } = useAppContext();

  const handleClose = async () => {
    setIsClosed(true);
    await markNotificationAsClosed('tracker_notifications', userId, tracker_notification_id);
  };

  if (isClosed) {
    return null;
  }

  return (
    <div className="macro-settings-alert">
      <div className="d-flex align-items-center gap-3 mb-m">
        <img src={macroSettings} alt="" />
        <p className="small text-text-main-color semi-bold mb-0">
          {t('customizeMacros.banner.headline')}
        </p>
      </div>

      <div className="d-flex align-items-center gap-2">
        <Button color="secondary" outline size="sm" className="w-100" onClick={handleClose}>
          {t('customizeMacros.banner.dismissButton')}
        </Button>
        <Button
          tag={Link}
          to={'/tracker/settings/macro'}
          state={{
            from: {
              pathname: '/tracker/settings/macro',
            },
          }}
          color="primary"
          size="sm"
          className="w-100"
          onClick={handleClose}
        >
          {t('customizeMacros.banner.customizeButton')}
        </Button>
      </div>
    </div>
  );
};

export default TrackerNotificationAlert;
